/* @flow */

export default class RegisterCompanyResponse {
  leadId: number;
  mustAnswerEligibilityTest: boolean;
}
